import { canSelectRevisionTemplate } from 'utils/revision-workflow';
import { Menu, Tooltip } from '@mantine/core';
import { IconCheck, IconChevronRight } from '@tabler/icons-react';
import { RevisionSingleActionProps } from 'components/tables/data/revision/types';
import { Link } from 'react-router-dom';
import {
  FILL_OUT_FORM_PAGE_PATH,
  FILL_OUT_REVISION_PAGE_PATH,
  SELECT_FORM_TEMPLATE_AND_VISUAL_PAGE_PATH,
  SELECT_REVISION_TEMPLATE_AND_VISUAL_PAGE_PATH,
} from 'routes/paths';

import ActionIcon from 'components/ActionIcon';
import Button from 'components/Button';
/**
 * Action performed by the revision technician to fill out the revision.
 */
export default function FillOutAction({ revision, kind }: RevisionSingleActionProps) {
  const revisionId = revision.revisionId;

  const path = canSelectRevisionTemplate(revision)
    ? revision.kind === 'revision'
      ? SELECT_REVISION_TEMPLATE_AND_VISUAL_PAGE_PATH.insert({ revisionId })
      : SELECT_FORM_TEMPLATE_AND_VISUAL_PAGE_PATH.insert({ revisionId })
    : revision.kind === 'revision'
    ? FILL_OUT_REVISION_PAGE_PATH.insert({ revisionId })
    : FILL_OUT_FORM_PAGE_PATH.insert({ revisionId });

  if (kind === 'action-icon') {
    return (
      <Tooltip label="Vypracovať" events={{ hover: true, focus: true, touch: true }}>
        <ActionIcon variant="secondary" size="md" component={Link} to={path}>
          <IconCheck />
        </ActionIcon>
      </Tooltip>
    );
  }

  if (kind === 'button') {
    return (
      <Button size="md" component={Link} to={path} leftIcon={<IconCheck />} variant="secondary" w={188}>
        Vypracovať
      </Button>
    );
  }

  return (
    <Menu.Item component={Link} to={path} icon={<IconChevronRight stroke="1.5" size={24} />} color="gray.8">
      Vypracovať
    </Menu.Item>
  );
}
